import type CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';

// Triggers that belong to the "Map" bucket for the contextual auth copy experiment (GROW-18025).
// When the sign up modal is shown on mWeb via one of these triggers, the headline is replaced with
// action-specific map copy. Keep in sync with the Map bucket defined on the experiment ticket.
const mapTriggers: CarouselDisplayTrigger[] = [
  'View Static Map',
  'Hit the Trail Card Open Map',
  'Flyover',
  'Select Map Overlay',
  'three d maps tapped',
  'Print Map',
  'Save Trail As Map',
  'Create Map',
  'Export Map File',
  'Hit the Trail Card Download Map'
];

export default mapTriggers;
